import { graphql, useStaticQuery } from 'gatsby';

// ** Types
import { MetaData } from 'types/metadata.types';
import { ImageData } from 'types/images.types';
import { PartnerType } from 'sections/partners/partner/partner.interfaces';

const query = graphql`
  query PartnersPage {
    partnersJson {
      metaData {
        title
        description
        openGraph {
          url
          title
          description
          image
          image_alt
          site_name
        }
      }
      previewSection {
        previewTitle
        previewImage {
          childImageSharp {
            gatsbyImageData(
              layout: FULL_WIDTH
              placeholder: BLURRED
              quality: 90
            )
          }
        }
      }
      aboutSection {
        title
        subtitle
        description
      }
      partners {
        id
        highlight
        text
        link
        background {
          childImageSharp {
            gatsbyImageData(
              layout: FULL_WIDTH
              placeholder: BLURRED
              quality: 90
            )
          }
        }
      }
    }
  }
`;

type PartnersPageData = {
  partnersJson: {
    metaData: MetaData;
    previewSection: {
      previewImage: ImageData;
      previewTitle: string;
    };
    aboutSection: {
      title: string;
      subtitle: string;
      description: string;
    };
    partners: PartnerType[];
  };
};

export const usePartnersData = (): PartnersPageData['partnersJson'] => {
  const data: PartnersPageData = useStaticQuery(query);

  return data.partnersJson;
};
